import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import React from 'react';

import { AddRowButtonProps } from './AddRowButton.props';
import { v4QuietButtonSx } from '../Button';

/**
 * The "add one more" control at the foot of a list inside a v4 panel.
 *
 * It sits at the *end of the list* rather than in the panel header, which is
 * where the outlined `ADD` pill used to float: that put a 40px empty band
 * between the heading and the first row of every panel on the Location tab, and
 * gave four lists four competing pills. As a last row it reads as part of the
 * list, and on an empty panel it becomes the empty state — the one thing there
 * is to do.
 */
export const AddRowButton: React.FC<AddRowButtonProps> = ({
  label,
  onClick,
  disabled = false,
  showDivider = false,
}) => (
  <Button
    startIcon={<AddIcon />}
    onClick={onClick}
    disabled={disabled}
    sx={{
      ...v4QuietButtonSx,
      width: '100%',
      justifyContent: 'flex-start',
      py: '7px',
      borderRadius: 0,
      borderTop: showDivider ? 1 : 0,
      borderColor: 'v4.border',
    }}
  >
    {label}
  </Button>
);
